import styled from 'styled-components'
import OnDemand from '../../components/WebDevelopment/OnDemand'
import NewFeatures from '../../components/WebDevelopment/NewFeatures'
import Debug from '../../components/WebDevelopment/Debug'
import Test from '../../components/TestContainer'

import { useEffect } from 'react'
import { usePageTitleContext } from '../../utils/hooks'

import { Helmet, HelmetProvider } from 'react-helmet-async'

const PageWrapper = styled.main`
    margin: auto;
    max-width: 2400px;
    @media screen and (min-width: 2399px) {
        box-shadow: rgb(226, 227, 233) 2px -2px 6px;
    }
`

function WebDevelopment() {

    const { title, setTitle } = usePageTitleContext()
    
    useEffect(() => {
        setTitle('Développement Web et applications');
    }, [title, setTitle]);

    // Set meta tags when On demand Page loads
    const usePageMeta = (title, description) =>{
        const defaultTitle = "Développement Web et applications sur-mesure";
        const defaultDesc = "Becom'in réalise sur-mesure votre site internet (vitrine, e-commerce) ou votre application mobile Android ou IOS, près de Caen en Normandie.";
    
        useEffect(() => {
            // Title meta tag
            document.title = title || defaultTitle;
            // Description meta tag
            document.querySelector("meta[name='description']").setAttribute("content", description || defaultDesc);
        }, [defaultTitle, title, defaultDesc, description]);
    };
    
    usePageMeta("Développement Web et applications sur-mesure", "Becom'in réalise sur-mesure votre site internet (vitrine, e-commerce) ou votre application mobile Android ou IOS, près de Caen en Normandie.");

    return (
        
        <HelmetProvider>
            <PageWrapper id='main-content'>
                <Helmet>
                    <link rel="canonical" href="https://www.becom-in.fr/developpement-web-android" />
                </Helmet>
                <OnDemand />
                <NewFeatures />
                <Debug />
                <Test />
            </PageWrapper>
        </HelmetProvider>
    )
}

export default WebDevelopment